import { BottomNavigationAction, useTheme } from "@mui/material"
import clsx from "clsx"
import { ICarouselNavigationMenuProps } from "components/CarouselNavigation"
import { useTranslation } from "providers/i18n"

export const CarouselNavigationMenu: React.FC<ICarouselNavigationMenuProps> = ({
  selected,
  label,
  icon,
  active_icon: activeIcon = icon,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { root } =
    theme.components[`CarouselNavigationMenu`]?.styleOverrides || {}

  return (
    <BottomNavigationAction
      className={clsx(
        "CarouselNavigationMenu-root",
        selected ? "Mui-selected" : ""
      )}
      sx={root}
      label={t(label)}
      icon={selected ? activeIcon : icon}
      {...props}
    />
  )
}
